<p>
  block-footer-admin works!
</p>
